export default __webpack_public_path__ + "img/plus-m.30021e12.svg";